import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';

const TwTabs = styled(Tabs)({
  borderBottom: '1px solid #E2E2EA',
  textTransform: 'none',
  '& .MuiTabs-indicator': {
    backgroundColor: '#3A4DE9',
    height: '2px',
    border: '1px solid #3A4DE9',
    borderRadius: '10px 10px 0 0',
    minWidth: '10px'
  }
});

export default TwTabs;
